module.exports = __webpack_public_path__ + "static/img/img-honor4.8d47a77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-honor4.png
// module id = RQy0
// module chunks = 1